<template>
    <div>
        <crud-delete :open="open"
            :loading="loading || loadingImpact"
            :title="title"
            :errorMessage="errorMessage"
            @delete="onDeleteClick"
            @close="$emit('close')"
        >
            <v-card-text>
                <marca-show-data :item="item" />
            </v-card-text>

            <v-card-text>
                <v-row justify="center">
                    <span class="title">{{ areYouSure }}</span>
                </v-row>
            </v-card-text>
        </crud-delete>

        <confirm-dialog v-model="showConfirmImpact"
            :title="$t('marca.modals.deleteImpact.title')"
            :description="impactDescription"
            confirm-color="error"
            max-width="400px"
            @confirmed="executeDelete"
        />
    </div>
</template>

<script>
    import MarcaProvider from "../../../providers/MarcaProvider";
    import MarcaShowData from "../MarcaShow/MarcaShowData";
    import { CrudDelete, ConfirmDialog } from '@dracul/common-frontend';
    import ClientError from "@/errors/ClientError";

    export default {
        name: "MarcaDelete",

        components: { MarcaShowData, CrudDelete, ConfirmDialog },

        props: {
            open: { type: Boolean, default: true },
            item: { type: Object, required: true }
        },

        data() {
            return {
                modal: false,
                title: 'marca.deleting',
                areYouSure: this.$t('common.areYouSureDeleteRecord'),
                errorMessage: '',
                loading: false,
                loadingImpact: false,
                showConfirmImpact: false,
                pendingImpact: null,
            }
        },

        computed: {
            impactDescription() {
                if (!this.pendingImpact) return ''
                const { productosCount, depositosCount } = this.pendingImpact
                const desc = this.$t('marca.modals.deleteImpact.description', {
                    productosCount,
                    depositosCount
                })
                const question = this.$t('marca.modals.deleteImpact.confirmQuestion')
                return `${desc} ${question}`
            }
        },

        methods: {
            onDeleteClick() {
                this.loadingImpact = true
                this.errorMessage = ''
                MarcaProvider.getMarcaUpdateImpact(this.item.id)
                    .then(r => {
                        if (r?.data?.marcaUpdateImpact) {
                            this.pendingImpact = r.data.marcaUpdateImpact
                            this.showConfirmImpact = true
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                    })
                    .finally(() => { this.loadingImpact = false })
            },
            executeDelete() {
                this.loading = true
                this.errorMessage = ''
                MarcaProvider.deleteMarca(this.item.id)
                    .then(result => {
                        if (result.data.marcaDelete.success) {
                            this.$emit('itemDeleted', result.data.marcaDelete)
                            this.$emit('close')
                        } else {
                            this.errorMessage = 'Error on Delete'
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                    })
                    .finally(() => {
                        this.loading = false
                        this.pendingImpact = null
                    })
            },
        },
    }
</script>


